import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import VueMask from 'v-mask';
import axios from 'axios';
import createStore from './store/create-store';
import App from './App.vue';
import apiBaseUrl from './api-base';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(VueMask);

const appElements = document.querySelectorAll('[id="beltoneApps"]');

axios.defaults.baseURL = apiBaseUrl;
window.iframes = window.iframes || {};
window.iframes.apiBaseUrl = apiBaseUrl;

appElements.forEach((el) => {
	const store = createStore();

	new Vue({
		store,
		render: h => h(App, {
			props: {
				page: el.getAttribute('page'),
				clinicUrl: el.getAttribute('clinic-url') || null,
				clinicId: el.getAttribute('clinic-id') || null,
				dealerId: el.getAttribute('dealer-id') || null,
				showMap: el.getAttribute('show-map') || 'false',
			},
		}),
	}).$mount(el);
});
